import React from "react"
import strings from "../../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import { EScheduleConstraintSeverity, IAssignedEmployeeConstraint } from "../../../models"
import DayTimelineBar from "../../../components/schedule/DayTimelineBar"
import ScheduleConstraintsTable from "../constraints/ScheduleConstraintsTable"
import EmployeeChip from "../../employee/EmployeeChip"

interface IProps {
    assignedEmployeeConstraints: IAssignedEmployeeConstraint
    payload?: any
    handleClose(): void
    handleSave?(payload): void
}

const CheckAssignedEmployeeConstraintDialog: React.SFC<IProps> = (props: IProps) => {
    const checkValidate = () => {
        return props.assignedEmployeeConstraints.Constraints.find(constraint => constraint.Severity === EScheduleConstraintSeverity.Error) === undefined
    }
    const handleSave = () => {
        if (!checkValidate()) return
        props.handleSave &&
            props.handleSave(props.payload)
    }
    return (
        <Dialog
            open
            title={strings.Confirm_Assigned_Employee_Constraints}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
                <FlatButton
                    data-intercom-target={"AssignEmployee-Btn-CloseAssignedEmployeeConstraintDialog"}
                    label={props.handleSave ? strings.CANCEL : strings.OK}
                    secondary
                    onClick={props.handleClose}
                />,
                props.handleSave &&
                <FlatButton
                    data-intercom-target={"AssignEmployee-Btn-SaveConstraints"}
                    label={strings.SAVE}
                    primary
                    onClick={handleSave}
                />
            ]}
        >
            <div style={{ marginTop: 20, paddingRight: 20, paddingLeft: 20 }}>
                <div style={{ height: 150 }}>
                    <div style={{ color: "rgb(97, 97, 97)", marginBottom: 10 }}>{strings.Shift_information}</div>
                    <DayTimelineBar
                        shiftTemplates={props.assignedEmployeeConstraints.SchedulePatternTemplate.ShiftTemplates}
                        totalWidth={888}
                    />
                </div>
                <EmployeeChip
                    readonly
                    selectedEmployee={props.assignedEmployeeConstraints.Employee}
                />
                <ScheduleConstraintsTable
                    constraints={props.assignedEmployeeConstraints.Constraints}
                />
            </div>
        </Dialog>
    )
}

export default CheckAssignedEmployeeConstraintDialog